<template>
    <div class="downloadList">
		<!-- 表单搜索部分 -->
		        <el-card class="box-card" shadow="hover">
		            <el-form :inline="true" :model="submitForm">
					<el-form-item>
						<el-date-picker
							v-model="submitForm.date"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="请选择对账日期"
						></el-date-picker>
					</el-form-item>
						<el-form-item>
						    <el-select
						        size
						        v-model="submitForm.controllers"
						        clearable
						        placeholder="请选择类型"
						    >
						        <el-option label="交易列表" value="1"></el-option>
						        <el-option label="终端列表" value="2"></el-option>
						        <el-option label="处罚扣款" value="3"></el-option>
						        <el-option label="押金列表" value="4"></el-option>
						        <el-option label="流量卡列表" value="5"></el-option>
						        <el-option label="商户列表" value="6"></el-option>
								<el-option label="代理财务记录列表" value="7"></el-option>
						    </el-select>
						</el-form-item>
						<el-form-item> 
		                    <el-button
		                        size="medium"
		                        type="primary"
		                        icon="el-icon-search"
		                        style="font-size: 12px;"
		                        @click="handleSearch(submitForm)"
		                    >查询</el-button>
		                </el-form-item>
		            </el-form>
		        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="downloadList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
                max-height="500px"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="文件名"
                    min-width="150"
                ></el-table-column>
                <!--&lt;!&ndash; 申请人 &ndash;&gt;-->
                <!--<el-table-column-->
                <!--    header-align="center"-->
                <!--    align="center"-->
                <!--    prop="admin_id"-->
                <!--    label="申请人"-->
                <!--    min-width="150"-->
                <!--&gt;</el-table-column>-->
                <!-- 创建时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="创建时间"
                    min-width="150"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.status == 20"
                            type="text"
                            size="small"
                        >
                            <el-link
                                :underline="false"
                                type="primary"
                                :href="scope.row.file_url"
                                target="_blank"
                                style="font-size:12px"
                            >下载</el-link>
                        </el-button>
                        <el-button v-else-if="scope.row.status == 10" type="text" size="small">队列中</el-button>
                        <el-button v-else-if="scope.row.status == 30" type="text" size="small">失败</el-button>
                        <el-button v-else type="text" size="small">处理中</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "downloadList",
    data() {
        return {
            downloadList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false,
			submitForm: {
				controllers:"",
			    date: '',
				page: 1,
				limit: 10
			},
        }
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
		handleSearch(searchFrom) { //搜索
		    this.currentPage = 1;
		    searchFrom.page = 1; 
		    this.getData(searchFrom);
		},
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.getData({
                page: page,
                limit: this.pageSize
            });
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.getData({
                page: this.currentPage,
                limit: limit
            });
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("export/list", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.downloadList = res.data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
